import React from "react";

const Loader = () => {
  return (
    <div className="flex h-screen w-full items-center justify-center align-middle dark:bg-[#2c2c2c] dark:text-white">
      <div className="relative flex items-center justify-center">
        <div className="absolute h-32 w-32 animate-spin rounded-full border-b-4 border-t-4 border-[#36454F]"></div>
        <img
          src="/images/logo/logo-main.png"
          className="h-16"
          alt="Loading..."
        />
      </div>
    </div>
  );
};

export default Loader;
